import { render, staticRenderFns } from "./ItineraryBlock.vue?vue&type=template&id=4d485124&"
import script from "./ItineraryBlock.vue?vue&type=script&lang=js&"
export * from "./ItineraryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports